import React from "react";
const Subtitle = ({ children }) => {
  return (
    <span
      style={{
        display: "block",
        marginTop: "0px",
        padding: "0px",
        // color: "#EEEEEE",
        whiteSpace: "pre-line",
        fontSize: "1em",
      }}
    >
      {children}
    </span>
  );
};

export default Subtitle;
